<template>
	<div class="container" v-loading.fullscreen.lock="fullscreenLoading">
		<cnHeader></cnHeader>
		<div class="page_content">
			<!--面包屑与公共提醒-开始-->
			<div class="ext_head">
				<div class="bread_crumb"><a href="/cn/">首页</a><span class="space">/</span>酒店</div>
			</div>
			<!--面包屑与公共提醒-结束-->
			<!--页面内容-开始-->
			<div class="public_content">
				
				<!--左侧-开始-->
				<div class="left_box">
					<div class="section_box">
						<h1>搜索条件</h1>
						<div class="search_box">
							<input type="text" class="input_keyword" v-model="keyword" maxlength="50" placeholder="请输入您感兴趣的内容" @keyup.enter="searchHandle()" />
							<div class="btn_search" @click="searchHandle()"></div>
						</div>
					</div>
					<div class="section_box">
						<h1>筛选条件</h1>
						<div class="filter_box">
							<div class="items_box">
								<div class="ft_title">
									<h4>按地区</h4>
									<span v-if="!(area==='' || area===null)"><a href="javascript:void(0)" @click="areaClear()">重置</a></span>
								</div>
								<ul>
									<li v-for="item in areaList" :key="item.Id" v-if="item.Id===area" class="selected"><a href="javascript:void(0)" @click="areaHandle(item.Id)">{{item.Title}}</a></li>
									<li v-else><a href="javascript:void(0)" @click="areaHandle(item.Id)">{{item.Title}}</a></li>
								</ul>
							</div>
							<div class="items_box">
								<div class="ft_title">
									<h4>按品牌</h4>
									<span v-if="!(brandType==='' || brandType===null)"><a href="javascript:void(0)" @click="brandTypeClear()">重置</a></span>
								</div>
								<ul>
									<li v-for="item in brandTypeList" :key="item.Id" v-if="item.Id===brandType" class="selected"><a href="javascript:void(0)" @click="brandTypeHandle(item.Id)">{{item.Title}}</a></li>
									<li v-else><a href="javascript:void(0)" @click="brandTypeHandle(item.Id)">{{item.Title}}</a></li>
								</ul>
							</div>
							<div class="items_box">
								<div class="ft_title">
									<h4>按级别</h4>
									<span v-if="!(star==='' || star===null)"><a href="javascript:void(0)" @click="starClear()">重置</a></span>
								</div>
								<ul>
									<li v-for="item in starList" :key="item.Id" v-if="item.Id===star" class="selected"><a href="javascript:void(0)" @click="starHandle(item.Id)">{{item.Title}}</a></li>
									<li v-else><a href="javascript:void(0)" @click="starHandle(item.Id)">{{item.Title}}</a></li>
								</ul>
							</div>
						</div>
					</div>
				</div>				
				<!--左侧-结束-->
				
				
				<div class="data_content">
					
					<!--排序-开始-->
					<div class="sort_box">
						<div class="total">
							<template v-if="!fullscreenLoading">
							共 <span class="bold">{{recordTotal}}</span> 条数据
							</template>
						</div>						
						<div class="sort">
							<span class="bold">{{sortList[sort].Title}}</span>
							<div class="popup">
								<ul>
									<li v-for="item in sortList" :key="item.Id" v-if="item.Id===sort" class="selected">{{item.Title}}</li>
									<li v-else @click="sortHandle(item.Id)">{{item.Title}}</li>
								</ul>
							</div>
						</div>
					</div>
					<!--排序-结束-->
					
					<!--无数据-->
					<cnNoData :isShow="noDataIsShow"></cnNoData>
					
					<!--列表-开始-->
					<div class="items">
						
						<div class="item_box" v-for="(item, index) in hotelList" :key="index">
							<a :href="'hotel/detail?Id='+item.HotelId" target="_blank"><img :src="item.Picture" /></a>
							<div class="right_box">
								<h3><a :href="'hotel/detail?Id='+item.HotelId" target="_blank">{{truncatedMessage(item.Title,80)}}</a></h3>
								<div v-if="item.StarPicture !=''" :class="'star s_'+item.StarPicture"></div>
								<h4><b v-if="item.Brand !=''">{{item.Brand}}&nbsp;&nbsp;</b>{{item.BrandType}}</h4>
								<h4><b>{{replaceTxt(item.Location)}}&nbsp;&nbsp;</b>{{item.Address}}</h4>
								<div class="bottom_box">
									<div class="comment_box">
										<!-- <template v-if="item.Comments.Amount>0">
										<span class="num">{{item.Comments.StarNumber}}</span><span class="total">共{{item.Comments.Amount}}条评论</span>
										</template>
										<template v-else>
										<span class="total">暂无任何评论</span>
										</template> -->
									</div>
									<div class="price_box">
										<div class="price">
											<span class="show_price">${{item.ShowPrice}}</span>
											<span class="sale_price">${{item.DiscountPrice}}</span>
										</div>
										<div class="tips">该价格已包含度假村费</div>
									</div>
								</div>
							</div>
						</div>
						
					</div>
					<!--列表-结束-->
					<!--分页-开始-->
					<div class="page_ctrl" v-if="this.hotelList.length>0">
						<el-pagination layout="prev, pager, next" :total="recordTotal" :current-page="pageIndex"
							:pager-count="5" :page-size="pageSize" :background="true" @current-change="handleCurrentChange">
						</el-pagination>
					</div>
					<!--分页-结束-->
				</div>
			</div>
			<!--页面内容-结束-->
		</div>
		<cnFooter></cnFooter>
	</div>
</template>


<script>
	import {
		getArea,
		getHotelBrandType,
		getHotelStar,
		getHotelList,
	} from '@/api/index.js'
	import { mixin } from '@/utils/mixin.js'
	import cnHeader from '@/components/cn_header.vue'
	import cnFooter from '@/components/cn_footer.vue'
	import cnNoData from '@/components/cn_noData.vue'
	export default {
		name: 'CN_HotelList',
		mixins:[mixin],
		components: {
			cnHeader,
			cnFooter,
			cnNoData,
		},
		data() {
			return {
				language: 'cn', 	//语言版本
				area: null,			//地区
				brandType: null,		//品牌类型
				star: null,			//级别
				sort: 0,			//排序
				keyword: '',		//关键词
				pageIndex: 1, 		//页码，默认为1
				pageSize: 10, 		//每页显示条数
				pageTotal: 0, 		//总页数
				recordTotal: 0, 	//总条数
				pageSlogan:'',		//Slogan
				areaList: [],		//地区列表
				brandTypeList: [],		//酒店品牌类型列表
				starList: [],		//酒店级别列表
				hotelList: [], 	//数据列表
				sortList: [
					{
						Id: 0,
						Title: '按 星级由高到低'
					},
					{
						Id: 1,
						Title: '按 星级由低到高'
					},
					{
						Id: 2,
						Title: '按 价格由低到高'
					},
					{
						Id: 3,
						Title: '按 价格由高到低'
					}
				],
				fullscreenLoading: true, //loading状态
				noDataIsShow: false, //无数据缺省
			}
		},
		created() {
			this.getAreaList()
			this.getBrandTypeList()
			this.getStarList()
			this.getData()
		},
		mounted() {
		},
		methods: {
			// 获取地区列表
			async getAreaList ()
			{
				const { data: res } = await getArea(this.language)
				if (res.errcode === 0) {
					this.areaList = res.data
				} else {
					this.$message.error(res.errmsg);
				}
			},
			// 获取酒店品牌类型列表
			async getBrandTypeList () {
				const { data: res } = await getHotelBrandType(this.language)
				if (res.errcode === 0) {
					this.brandTypeList = res.data
				} else {
					this.$message.error(res.errmsg);
				}
			},
			// 获取酒店级别列表
			async getStarList () {
				const { data: res } = await getHotelStar(this.language)
				if (res.errcode === 0) {
					this.starList = res.data
				} else {
					this.$message.error(res.errmsg);
				}
			},
			// 获取数据列表
			async getData ()
			{
				this.fullscreenLoading = true
				this.hotelList = []
				const { data: res } = await getHotelList(this.language, this.area, this.brandType, this.star, this.sort, this.keyword, this.pageIndex)
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					this.pageSlogan = res.data.ColumnSlogan
					this.hotelList = res.data.DataList
					this.pageTotal = res.data.PageTotal
					this.recordTotal = res.data.RecordTotal
					if (res.data.DataList.length > 0) {
						this.noDataIsShow = false
						this.$nextTick(() => {
							window.scrollTo(0, 0);
						});
					} else {
						this.noDataIsShow = true
					}
				} else {
					this.$message.error(res.errmsg);
				}
			},
			// 点选地区
			areaHandle(Id)
			{
				if(this.area != Id)
				{
					this.area = Id
					this.pageIndex = 1
					this.getData()
				}
			},
			// 清空地区
			areaClear()
			{
				this.area = null
				this.pageIndex = 1
				this.getData()
			},			
			// 点选品牌类型
			brandTypeHandle(Id)
			{
				if(this.brandType != Id)
				{
					this.brandType = Id
					this.pageIndex = 1
					this.getData()
				}
			},
			// 清空品牌类型
			brandTypeClear()
			{
				this.brandType = null
				this.pageIndex = 1
				this.getData()
			},
			
			// 点选级别
			starHandle(Id)
			{
				if(this.star != Id)
				{
					this.star = Id
					this.pageIndex = 1
					this.getData()
				}
			},
			// 清空级别
			starClear()
			{
				this.star = null
				this.pageIndex = 1
				this.getData()
			},
			
			// 排序
			sortHandle(Id)
			{
				this.sort = Id
				this.pageIndex = 1
				this.getData()
			},
			
			// 关键字搜索
			searchHandle()
			{
				this.pageIndex = 1
				this.getData()
			},
			
			//切换页码
			handleCurrentChange(val) {
				this.pageIndex = val
				this.getData()
			},
		}
	}
</script>

<style lang="less" scoped>
	.container {
		width: 100%;
		box-sizing: border-box;
		
		/*页面内容*/
		.data_content {
			min-height: 700px;
		
			/*列表*/
			.items {
				margin-top: 11px;
				width: 100%;
				position: relative;
		
				.it_s {
					width: 30px;
					height: 330px;
				}
				
				.item_box {
					width: 100%;
					background-color: #fff;
					border: #DFE0E3 solid 1px;
					border-radius: 8px;
					margin-bottom: 24px;
					position: relative;
					display: flex;
					justify-content: space-between;
					-webkit-transition: all .3s ease;
					
					
					img {
						width: 300px;
						height: 200px;
						border-top-left-radius: 7px;
						border-bottom-left-radius: 7px;
						display: block;
					}
					
					.right_box {
						width: 69.5%;
						height: 200px;
						padding: 14px 20px 20px 0;
						box-sizing: border-box;
						position: relative;
						
						h3 {
							margin-bottom: 14px;
							a {
								font-size: 18px;
								font-weight: 500;
								line-height: 160%;
								text-decoration: underline;
							}
						}
						
						h4 {
							margin-top: 6px;
							font-size: 13px;
							font-weight: 400;
						}
						h4.bold {
							font-weight: 500;
						}
						
						.star {
							height: 16px;
							background-position: left center;
							background-repeat: no-repeat;
							background-size: auto 14px;
						}
						.s_5 {								
							background-image: url(@/assets/images/icons/h_s_5.png);
						}
						.s_45 {								
							background-image: url(@/assets/images/icons/h_s_45.png);
						}
						.s_4 {								
							background-image: url(@/assets/images/icons/h_s_4.png);
						}
						.s_35 {								
							background-image: url(@/assets/images/icons/h_s_35.png);
						}
						.s_3 {								
							background-image: url(@/assets/images/icons/h_s_3.png);
						}
						.s_25 {								
							background-image: url(@/assets/images/icons/h_s_25.png);
						}
						.s_2 {								
							background-image: url(@/assets/images/icons/h_s_2.png);
						}
						.s_15 {								
							background-image: url(@/assets/images/icons/h_s_15.png);
						}
						.s_1 {								
							background-image: url(@/assets/images/icons/h_s_1.png);
						}
						
						.bottom_box {
							width: 100%;
							position: absolute;
							padding: 0 20px 14px 0;
							box-sizing: border-box;
							bottom: 0;
							display: flex;
							justify-content: space-between;
							align-items: flex-end;
							
							.comment_box {
								width: 200px;
								span {
									display: inline-block;
									vertical-align: middle;
								}
								span.num {
									width: 40px;
									height: 24px;
									line-height: 24px;
									background-color: #3D7856;
									border-radius: 5px;
									color: #fff;
									font-size: 13px;
									font-weight: 500;
									text-align: center;
									margin-right: 10px;
								}
								span.total {
									color: #666666;
									font-size: 12px;
								}
							}
							
							.price_box {
								text-align: right;
								
								.price {
									span {
										display: inline-block;
										vertical-align: middle;
									}
									span.show_price {
										font-size: 18px;
										color: #666;
										text-decoration: line-through;
									}
									span.sale_price {
										margin-left: 16px;
										font-size: 24px;
										font-weight: 500;
									}
								}
								
								.tips {
									margin-top: 6px;
									font-size: 13px;
									color: #3D7856;
								}
							}
						}
					}
				}
				.item_box:hover {
					background-color: #FAFFF9;
					box-shadow: 0px 0px 8px #ddd;
				}
				
			}
		}
		
		/deep/ .el-pagination {
			font-size: 16px;
		}
		
		/deep/ .el-pager li {
			width: 36px;
			height: 36px;
			font-size: 16px;
			line-height: 36px;
			margin: 0 5px;
			border-radius: 5px;
		}
		
		/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
			background-color: #3D7856;
			font-size: 16px;
		}
		
		/deep/ .el-pagination button {
			width: 36px;
			height: 36px;	
			border-radius: 5px;
		}
		
		/deep/ .el-pagination .btn-next .el-icon {
			font-size: 16px;
		}
		/deep/ .el-pagination .btn-prev .el-icon {			
			font-size: 16px;
		}

	}
</style>